import React from 'react';
import { StyleSheet, View } from 'react-native';
import BodyXSBoldText from 'shared/components/vxl/typography/primary/body/BodyXSBoldText';
import ChildNodeRenderer from 'shared/renderer/ChildNodeRenderer/ChildNodeRenderer';
import { VXLChildNode } from 'shared/renderer/types';
import theme from 'shared/styles/theme';

export interface CardGroupProps {
  titleText: string;
  components: VXLChildNode[];
}

const CardGroup = ({ titleText, components }: CardGroupProps) => {
  return (
    <View style={styles.container}>
      <BodyXSBoldText numberOfLines={1} style={styles.title}>
        {titleText}
      </BodyXSBoldText>
      {components.map((component) => {
        return (
          <View key={`${component.id}`}>
            <ChildNodeRenderer toRender={component} />
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    gap: theme.spacing.s,
  },
  title: {
    color: theme.color.text.secondary,
  },
});

export default CardGroup;
